import { Component, Show } from 'solid-js';

export interface ProductEvent {
    id: number;
    name: string;
    url: string;
    mediaName: string;
    mediaUrl: string;
    start: Date;
    end: Date;
    ingress: string;
    description: string|null;
}

interface EventProps {
    product: ProductEvent;
}

export const Event: Component<EventProps> = (props) => {
    function trimDescription(desc: string|null) {
        if (desc == null) {
            return '';
        }
        
        if (desc.length <= 150) {
            return desc;
        }
        
        return `${desc.substring(0, 150).trim()}...`;
    }
    
    return (
        <li class="citybreak__event">
            <a href={props.product.url}
               title={props.product.name}
               aria-label={props.product.name}
               class="citybreak__event-link">
                <Show when={props.product.mediaUrl}>
                    <img src={props.product.mediaUrl}
                         alt={props.product.mediaName}
                         title={props.product.mediaName}
                         aria-label={props.product.mediaName}
                         class="citybreak__event-image" />
                </Show>
                <div class="citybreak__event-body">
                    <h3 class="citybreak__event-header">
                        {props.product.name}
                    </h3>
                    <p class="citybreak__event-description">
                        {trimDescription(props.product.ingress)}
                    </p>
                </div>
            </a>
        </li>
    );
}

export default Event;
